import React from "react";

import "./InstallerPackField.css";

function InstallerPackField({ title, value, children }) {
  return (
    <div>
      <p className="bold text-left mb-1">{title}</p>
      <div className="installer-pack-value mb-3">
        <p className="text-left my-1 ml-3">{value ? value : "n/a"}</p>
        {children}
      </div>
    </div>
  );
}

export default InstallerPackField;
